import React from 'react';
import {Box} from '@mui/material';
import {NAVY, TEXTE, TEXTE_SECONDAIRE} from '../../tokens.js';
import ChipFiltre from '../ChipFiltre.js';
import CircuitsSelect from '../CircuitsSelect.js';
import {boutonPiluleSx} from './dashStyles.js';

const BARRE = {display: 'flex', alignItems: 'center', gap: '16px', p: '12px 32px', backgroundColor: '#FFFFFF', borderBottom: '1px solid #E3E7EC', flexWrap: 'wrap'};
const TITRE = {m: 0, fontSize: 20, fontWeight: 800, color: NAVY};
const SEPARATEUR = <Box sx={{width: '1px', height: 24, backgroundColor: '#DDE2E8'}}/>;

/** R1 : ligne période (nom du territoire, groupes, période, date des données, export CSV). */
export default function DashLignePeriode({nom, index, groupes, patrimoines, onPatrimoines, onGroupe, periodes, periodeId, onPeriode, selectRef, donneesAu, onExport, exportActif, onExportCollecte = null}) {
    return (
        <Box sx={BARRE}>
            <Box component="h1" sx={TITRE}>{nom}</Box>
            <Box role="group" aria-label="Patrimoines" sx={{display: 'flex', gap: '8px'}}>
                {[groupes.intra, groupes.extra].map((g) => {
                    const nb = g.ids.filter((id) => patrimoines.includes(id)).length;
                    return (
                        <ChipFiltre
                            key={g.id}
                            label={g.libelle}
                            checked={g.ids.length > 0 && nb === g.ids.length}
                            indeterminate={nb > 0 && nb < g.ids.length}
                            onChange={(v) => onGroupe(g.id, v)}
                        />
                    );
                })}
                <CircuitsSelect index={index} valeur={patrimoines} onChange={onPatrimoines}/>
            </Box>
            {SEPARATEUR}
            <Box component="label" sx={{display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: 12, color: TEXTE_SECONDAIRE}}>
                Période
                <Box
                    component="select"
                    ref={selectRef}
                    value={periodeId}
                    onChange={(e) => onPeriode(e.target.value)}
                    sx={{height: 34, p: '0 10px', border: '1px solid #D5DAE1', borderRadius: '999px', backgroundColor: '#FFFFFF', font: 'inherit', fontSize: 13, fontWeight: 600, color: TEXTE}}
                >
                    {periodes.map((p) => <option key={p.id} value={p.id}>{p.libelle}</option>)}
                </Box>
            </Box>
            <Box component="span" sx={{fontSize: 12, color: TEXTE_SECONDAIRE}}>Données au {donneesAu}</Box>
            <Box sx={{flex: '1 1 100px'}}/>
            <Box component="button" type="button" disabled={!exportActif} onClick={onExport} sx={boutonPiluleSx}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="m7 10 5 5 5-5"/><path d="M5 20h14"/></svg>
                Exporter (CSV)
            </Box>
            {onExportCollecte && (
                <Box component="button" type="button" onClick={onExportCollecte} sx={boutonPiluleSx}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="m7 10 5 5 5-5"/><path d="M5 20h14"/></svg>
                    Exporter la collecte (CSV)
                </Box>
            )}
        </Box>
    );
}

/** Ligne période du chargement : titre, sélecteur en squelette, indicateur de calcul. */
export function DashLignePeriodeChargement({nom}) {
    return (
        <Box sx={BARRE}>
            <Box component="h1" sx={TITRE}>{nom}</Box>
            {SEPARATEUR}
            <Box sx={{width: 260, height: 34, backgroundColor: '#E6EAEE', borderRadius: '999px'}}/>
            <Box sx={{flex: '1 1 100px'}}/>
            <Box role="status" aria-live="polite" sx={{display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: 13, color: TEXTE_SECONDAIRE}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>
                Calcul des indicateurs de la campagne…
            </Box>
        </Box>
    );
}
